import styled from 'styled-components';
import { spacing, colors } from 'ui/theme';
import { Button } from 'ui/button';

export const AssetListWrapper = styled.div`
  width: 33%;
  min-width: ${spacing.x16};
  padding-right: ${spacing.plusHalf};
  border-right: 1px solid ${colors.borderPrimary};
  display: flex;
  flex-direction: column;
  align-items: stretch;
  flex-shrink: 0;
  overflow-y: auto;
`;

export const AddAssetButton = styled(Button)`
  display: flex;
  justify-content: start;
  align-self: flex-start;
  width: 100%;
  margin: ${spacing.base} 0;
  padding: ${spacing.plusHalf} ${spacing.threeQuarter};
  p {
    color: ${colors.textDisabled};
  }
`;
